import { Form } from 'react-bootstrap';

export const RoomReassignmentStep = () => {
  return (
    <Form>
      <Form.Group>{/* TODO: add components for room assignment */}</Form.Group>
    </Form>
  );
};
